import { ArrowUpRight, CircleAlert, GitBranch, MoveRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Project } from '../../shared/types';
import { healthLabels, stageLabels } from '../lib/format';

export function ProjectCard({ project, compact = false }: { project: Project; compact?: boolean }) {
  const blockers = project.workItems.filter((item) => item.type === 'roadblock' && item.state !== 'done' && item.state !== 'dropped').length;
  return (
    <article className={`project-card accent-${project.accent} ${compact ? 'is-compact' : ''}`}>
      <div className="project-card__signal" />
      <div className="project-card__topline">
        <span className="mono eyebrow">{project.eyebrow}</span>
        <span className={`health health-${project.health}`}>{healthLabels[project.health]}</span>
      </div>
      <h3>{project.name}</h3>
      {!compact && <p>{project.summary}</p>}
      <div className="progress-line" aria-label={`${project.progress}% complete`}>
        <span style={{ width: `${project.progress}%` }} />
      </div>
      <div className="project-card__meta">
        <span><GitBranch size={14} /> {stageLabels[project.stage]}</span>
        {blockers > 0 && <span className="warning"><CircleAlert size={14} /> {blockers} blocker{blockers === 1 ? '' : 's'}</span>}
      </div>
      <Link className="card-link" to={`/projects/${project.slug}/overview`} aria-label={`Open ${project.name}`}>
        Open workspace <MoveRight size={16} />
      </Link>
      {project.links[0]?.kind === 'repository' && (
        <a className="corner-link" href={project.links[0].url} target="_blank" rel="noreferrer" aria-label={`Open ${project.name} repository`}><ArrowUpRight size={16} /></a>
      )}
    </article>
  );
}
